import React, { useEffect, useState } from "react";
import { Plus, Upload, Search } from "lucide-react";
import PageHeader from "@/components/admin/PageHeader";
import { adminApi } from "@/lib/api";
import { formatDateTime } from "@/lib/format";

export default function Contacts() {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [q, setQ] = useState("");

    useEffect(() => {
        adminApi.get("/api/admin/contacts").then((r) => {
            setItems(r.data.items || []);
            setTotal(r.data.total || 0);
        });
    }, []);

    const filtered = q
        ? items.filter((c) =>
              [c.name, c.email, c.mobile, c.hotel]
                  .filter(Boolean)
                  .some((v) => v.toLowerCase().includes(q.toLowerCase()))
          )
        : items;

    return (
        <div className="p-10 max-w-7xl">
            <PageHeader
                eyebrow="CRM"
                title="Contacts"
                description="Every guest Priya has spoken with — captured at the start of each chat."
                testid="page-contacts"
                action={
                    <div className="flex items-center gap-2">
                        <button className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-md border border-stone-200 bg-white hover:bg-stone-50">
                            <Upload size={14} /> Import
                        </button>
                        <button
                            data-testid="contacts-add"
                            className="inline-flex items-center gap-2 text-sm px-4 py-2 rounded-md bg-orchid-700 hover:bg-orchid-600 text-white"
                        >
                            <Plus size={14} /> Add contact
                        </button>
                    </div>
                }
            />

            <div className="bg-white border border-stone-200 rounded-lg overflow-hidden">
                <div className="p-4 border-b border-stone-100 flex items-center justify-between gap-3">
                    <div className="text-xs text-stone-500">
                        <span className="font-medium text-stone-900">{total}</span> items
                    </div>
                    <div className="relative">
                        <Search size={14} className="absolute left-3 top-2.5 text-stone-400" />
                        <input
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                            placeholder="Search…"
                            data-testid="contacts-search"
                            className="pl-8 pr-3 py-2 rounded-md border border-stone-200 text-sm w-64 focus:outline-none focus:border-orchid-700"
                        />
                    </div>
                </div>

                {filtered.length === 0 ? (
                    <div className="p-16 text-center">
                        <p className="text-sm text-stone-500">
                            {q ? "No contacts match your search." : "No contacts yet — start a chat to capture your first lead."}
                        </p>
                    </div>
                ) : (
                    <table className="w-full text-sm" data-testid="contacts-table">
                        <thead className="bg-stone-50 text-stone-500 text-xs uppercase tracking-[0.08em]">
                            <tr>
                                <th className="text-left px-5 py-3 font-medium">Name</th>
                                <th className="text-left px-5 py-3 font-medium">Email</th>
                                <th className="text-left px-5 py-3 font-medium">Mobile</th>
                                <th className="text-left px-5 py-3 font-medium">Hotel</th>
                                <th className="text-left px-5 py-3 font-medium">First seen</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((c) => (
                                <tr key={c.id} className="border-t border-stone-100 hover:bg-stone-50">
                                    <td className="px-5 py-3 text-stone-900 font-medium">{c.name || "—"}</td>
                                    <td className="px-5 py-3 text-stone-700">{c.email || "—"}</td>
                                    <td className="px-5 py-3 text-stone-700">{c.mobile || "—"}</td>
                                    <td className="px-5 py-3 text-stone-700">{c.hotel || "—"}</td>
                                    <td className="px-5 py-3 text-stone-500 text-xs">{formatDateTime(c.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
